import {useInjection} from "inversify-react";
import {useCallback, useEffect, useState} from "react";
import ApiService from "../../../services/apiService";
import {ProductDetailApi, ProductDetailCreateDto, ProductDetailUpdateDto} from "../../../api";
import ProductDetailModalForm from "./productDetailModalForm";
import {useParams} from "react-router-dom";

export default function ProductDetailModalFormAddContainer(props: ProductDetailModalFormAddContainerProps) {
    const apiService = useInjection(ApiService);
    const [productDetailToEdit, setProductDetailToEdit] = useState<ProductDetailUpdateDto | null>(null);
    let {productId} = useParams();

    const onSubmit = useCallback(async (values: ProductDetailCreateDto | ProductDetailUpdateDto) => {

        try {
            if (!props.id) {
                values.productId = +productId!;
                await apiService.getApi(ProductDetailApi).apiProductDetailPost(values);
            } else {
                values.productId = +productId!;
                await apiService.getApi(ProductDetailApi).apiProductDetailIdPut(props.id, values)
            }

            await props.onFinish(true);
        } catch (e: any) {
            return e.response.data;
        }
    }, [apiService, props.id]);

    const getProductDetailToEdit = useCallback(async () => {

        if (!props.id) {
            return;
        }

        const response = await apiService.getApi(ProductDetailApi).apiProductDetailIdGet(props.id);

        setProductDetailToEdit(response.data);

    }, [apiService, props.id]);

    useEffect(() => {
        getProductDetailToEdit();
        return () => setProductDetailToEdit(null);
    }, [getProductDetailToEdit]);

    if (props.id && !productDetailToEdit) {
        return null;
    }

    if (props.id === null && productDetailToEdit) {
        return null;
    }

    return <>
        <ProductDetailModalForm
            isModalVisible={props.addFormVisibility}
            setModalVisibility={props.onFinish}
            onSubmit={onSubmit}
            modalTitle={props.title}
            saveButtonTitle={"Zapisz"}
            cancelButtonTitle={"Anuluj"}
            initialValues={productDetailToEdit!}
        />
    </>
}

interface ProductDetailModalFormAddContainerProps {
    onFinish: (refreshList: boolean) => void,
    addFormVisibility: boolean,
    title: string,
    id?: number | null
}
